import { PostAttendeeActionsActionTypes } from "./types";
export function getLookups(lookupId, eventNumber) {
    return {
        type: PostAttendeeActionsActionTypes.GET_LOOKUPS,
        payload: {
            lookupId: lookupId,
            eventNumber: eventNumber,
        },
    };
}
export function setLookups(lookups) {
    return {
        type: PostAttendeeActionsActionTypes.SET_LOOKUPS,
        payload: lookups,
    };
}
export function getAttendees(lookupId, eventNumber, includeGroups, includeOrders) {
    return {
        type: PostAttendeeActionsActionTypes.GET_ATTENDEES,
        payload: {
            lookupId: lookupId,
            eventNumber: eventNumber,
            includeGroups: includeGroups,
            includeOrders: includeOrders,
        },
    };
}
export function setAttendees(attendees) {
    return {
        type: PostAttendeeActionsActionTypes.SET_ATTENDEES,
        payload: attendees,
    };
}
export function getOrders(lookupId, eventNumber) {
    return {
        type: PostAttendeeActionsActionTypes.GET_ORDERS,
        payload: {
            lookupId: lookupId,
            eventNumber: eventNumber,
        },
    };
}
export function setOrders(orders) {
    return {
        type: PostAttendeeActionsActionTypes.SET_ORDERS,
        payload: orders,
    };
}
export function getGroup(lookupId, eventNumber) {
    return {
        type: PostAttendeeActionsActionTypes.GET_GROUP,
        payload: {
            lookupId: lookupId,
            eventNumber: eventNumber,
        },
    };
}
export function setGroup(group) {
    return {
        type: PostAttendeeActionsActionTypes.SET_GROUP,
        payload: group,
    };
}
export function setPaymentRequiredPayload(paymentRequiredPayload) {
    return {
        type: PostAttendeeActionsActionTypes.SET_PAYMENT_REQUIRED_PAYLOAD,
        payload: paymentRequiredPayload,
    };
}
